import script from "./custom-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./custom-button.vue?vue&type=script&setup=true&lang=ts"

import "./custom-button.vue?vue&type=style&index=0&id=3ff53ff4&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff53ff4"]])

export default __exports__